import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { GoalMateProgram, GoalMateProgramGroup } from '@goalmate/typings';

export const ContentActions = createActionGroup({
  source: 'Content/API',
  events: {
    'Load Contents': props<{ programId: string }>(),
    'Load Contents Success': props<{
      contents: GoalMateProgramGroup[];
      program: GoalMateProgram;
    }>(),
    'Load Contents Error': props<{ error: string }>(),
    'Add Content': props<{ content: GoalMateProgramGroup }>(),
    'Upsert Content': props<{ content: GoalMateProgramGroup }>(),
    'Add Contents': props<{ content: GoalMateProgramGroup[] }>(),
    'Upsert Contents': props<{ content: GoalMateProgramGroup[] }>(),
    'Update Content': props<{ content: Update<GoalMateProgramGroup> }>(),
    'Update Contents': props<{ contents: Update<GoalMateProgramGroup>[] }>(),
    'Delete Content': props<{ id: string }>(),
    'Delete Contents': props<{ ids: string[] }>(),
    'Clear Contents': emptyProps(),
    'Select Content': props<{ contentId: string | null; groupId: string }>(), // Loads and selects content
    'Unselect Content': emptyProps(),
    'Update Program': props<{ program: Partial<GoalMateProgram> }>(),
  },
});
